<template>
  <div v-if="visible" class="wsm-mask" @click.self.prevent>
    <div class="wsm-dialog">
      <img class="wsm-icon" src="../../assets/withdrawal_v2/ok.png" alt="" />
      <p class="wsm-title">{{ $t("guild_withdraw_submit_success") }}</p>
      <p class="wsm-text">{{ $t(tipKey, resolvedTipParams) }}</p>
      <button type="button" class="wsm-btn" @click="$emit('confirm')">
        {{ $t("guild_got_it") }}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * 提现提交成功弹窗（2026-06-08）
 * 替代旧页 changeMate 全屏成功态；点「知道了」跳转 /withdrawal；点击遮罩不关闭
 */
export default {
  name: "withdraw-success-modal",
  props: {
    visible: { type: Boolean, default: false },
    /** 到账天数，用于文案 {s} 占位（自提现） */
    workdays: { type: [Number, String], default: 3 },
    /** 成功说明文案 i18n key */
    tipKey: { type: String, default: "guild_withdraw_success_tip" },
    /** 成功说明文案插值 */
    tipParams: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    // 成功文案插值：父组件传了 tipParams 则直接使用，否则用到账天数 workdays 填充 {s}
    resolvedTipParams() {
      if (Object.keys(this.tipParams).length) {
        return this.tipParams;
      }
      return { s: this.workdays };
    },
  },
};
</script>

<style scoped>
.wsm-mask {
  position: fixed;
  inset: 0;
  z-index: 500;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 0 48px; */
  box-sizing: border-box;
}

.wsm-dialog {
  width: 100%;
  max-width: 590px;
  background: #fff;
  border-radius: 24px;
  padding: 32px;
  box-sizing: border-box;
  text-align: center;
  font-family: "Mada", sans-serif;
}

.wsm-icon {
  display: block;
  width: 112px;
  height: 112px;
  margin: 0 auto 24px;
}

.wsm-title {
  margin: 0 0 16px;
  font-size: 24px;
  font-weight: 500;
  color: #262427;
}

.wsm-text {
  margin: 16px 0 40px;
  font-size: 20px;
  line-height: 30px;
  font-weight: 400;
  color: #262427;
}

.wsm-btn {
  display: block;
  width: 412px;
  height: 80px;
  border: none;
  border-radius: 40px;
  background: #8131e7;
  font-size: 24px;
  font-weight: 500;
  color: #fff;
  margin: 0 auto;
}

/* 阿语 RTL 适配（2026-06-08） */
html[lang="ar"] .wsm-dialog {
  direction: rtl;
}
</style>
